import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const DashboardContext = createContext()

const DashboardProvider = ({ children }) => {

    const { auth, toast } = useAuth();

    const headers = {
        Authorization: auth?.token,
    };

    const getActiveMembersInLocation = async () => {
        try {
            let { data } = await axios.get(`${baseURL}/admin/location/members/active`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const getMemberStatus = async () => {
        try {
            let { data } = await axios.get(`${baseURL}/admin/user/members/status`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    return (
        <DashboardContext.Provider value={{ getActiveMembersInLocation, getMemberStatus}}>
            {children}
        </DashboardContext.Provider>
    )
}

const useDashboard = () => useContext(DashboardContext)

export { useDashboard, DashboardProvider, }